import { FileListing } from './file';
import { StockItemListing } from './item';
import { VendorListing, VendorSummary } from './vendor';

export class StockItemVendor {
   stockItemId: number;
   stockItem: StockItemListing;
   vendorId: number;
   vendor: VendorSummary;
   code: string;
   isPreferred: boolean;
   price: number;
   stockNumber: string;

    constructor(){
      this.stockItemId = 0;
      this.stockItem = null;
      this.vendorId = 0;
      this.vendor = null;
      this.code = '';
      this.isPreferred = false;
      this.price = 0;
      this.stockNumber = '';
    }
}
